import styled from "styled-components";
import NoSearchResultImage from "@local/icons/component/NoSearchResultIcon"

export const NoSearchResultIcon = styled(NoSearchResultImage)`
	width: 150px;
`;

export const Container = styled.div`
	margin: 50px auto;
	text-align: center;
	width: 100%;
`;


